import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { ReactComponent as SvgAvatar } from "../../assets/images/menu/avatar.svg";
import { ReactComponent as SvgBook } from "../../assets/images/menu/book.svg";
import { ReactComponent as SvgBox } from "../../assets/images/menu/box.svg";
import { ReactComponent as SvgCase } from "../../assets/images/menu/case.svg";
import { ReactComponent as SvgSetting } from "../../assets/images/menu/setting.svg";
import { ReactComponent as SvgStatistic } from "../../assets/images/menu/statistic.svg";
import { ReactComponent as SvgTable } from "../../assets/images/menu/table.svg";


import "./UiMenu.scss";

function UiMenu(props) {
  const [clientsOpen, setClientsOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [materialOpen, setMaterialOpen] = useState(false);

  let location = useLocation();

  useEffect(() => {
    setClientsOpen(false);
    setProductsOpen(false)

  }, [location])

  let categoriesList = (props.category ? props.category.tagsList : []).map((item, index) => {
    let dataList = item.data.map((itemData, indexData) => {
      return (
        <Link
          key={indexData}
          className={
            "menu-left-panel-item" +
            (location.pathname === `/products/category/${itemData.id}` ? " active" : "")
          }
          onClick={() => setProductsOpen(false)}
          to={`/products/category/${itemData.id}`}
        >
          <span className="sub-title">{itemData.title}</span> 
        </Link>

      )
    });

    return (
      <div>
        <Link
          key={index}
          className={
            "menu-left-panel-item" +
            (location.pathname === `/products/category/${item.id}` ? " active" : "")
          }
          onClick={() => setProductsOpen(false)}
          to={`/products/category/${item.id}`}
        >
          <span className="main-title">{item.title}</span>
           
        </Link>
        {dataList}
      </div>
    )
  })

  return (
    <div className="menu-left">
      <div className="menu-left-list">
        <Link
          className={
            "menu-left-item" + (location.pathname === "/" ? " active" : "")
          }
          to="/"
        >
          <div className="menu-left-item-wrap">
            <SvgCase className="menu-left-item-icon" />
          </div>
          <span>Заказы</span>
        </Link>

        <button
          className={
            "menu-left-item" +
            (location.pathname === "/clients" ? " active" : "")
          }
          onClick={() => {
            setClientsOpen(!clientsOpen);
            setProductsOpen(false)
            setMaterialOpen(false)
          }}
        >
          <div className="menu-left-item-wrap">
            <SvgAvatar className="menu-left-item-icon" />
          </div>
        </button>

        <button
          className={
            "menu-left-item" + (productsOpen ? " active" : "")
          }
          onClick={() => {
            setClientsOpen(false);
            setMaterialOpen(false)
            setProductsOpen(!productsOpen)
          }}
        >
          <div className="menu-left-item-wrap">
            <SvgTable className="menu-left-item-icon" />
          </div>
          <span>Товары</span>
        </button>

        {/*
        <button
          className={
            "menu-left-item" + (materialOpen ? " active" : "")
          }
          onClick={() => {
            setClientsOpen(false);
            setProductsOpen(false)
            setMaterialOpen(!materialOpen)
          }}
        >
          <div className="menu-left-item-wrap">
            <SvgBook className="menu-left-item-icon" />
          </div>
          <span>Материалы</span>
        </button>
        */}

        <Link
          className={
            "menu-left-item" +
            (location.pathname === "/material/list" ? " active" : "")
          }
          to="/menu"
        >
          <div className="menu-left-item-wrap">
            <SvgBook className="menu-left-item-icon" />
          </div>
          <span>Верхнее меню</span>
        </Link>

        
        <Link
          className={
            "menu-left-item" +
            (location.pathname === "/material/list" ? " active" : "")
          }
          to="/material/list"
        >
          <div className="menu-left-item-wrap">
            <SvgBook className="menu-left-item-icon" />
          </div>
          <span>Акции</span>
        </Link>

       


        <Link
          className={
            "menu-left-item" +
            (location.pathname === "/archive" ? " active" : "")
          }
          to="/archive"
        >
          <div className="menu-left-item-wrap">
            <SvgBox className="menu-left-item-icon" />
          </div>
          <span>Архив заказов</span>
        </Link>

        <Link
          className={
            "menu-left-item" +
            (location.pathname === "/statistic" ? " active" : "")
          }
          to="/statistic"
        >
          <div className="menu-left-item-wrap">
            <SvgStatistic className="menu-left-item-icon" />
          </div>
          <span>Статистика</span>
        </Link>

        <Link
          className={
            "menu-left-item" +
            (location.pathname === "/setting" ? " active" : "")
          }
          to="/setting"
        >
          <div className="menu-left-item-wrap">
            <SvgSetting className="menu-left-item-icon" />
          </div>
          <span>Настройки</span>
        </Link>

      </div>

      <div className={"menu-left-panel" + (clientsOpen ? " active" : "")}>
        <div className="menu-left-panel-list">
          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === "/clients" ? " active" : "")
            }
            onClick={() => setClientsOpen(false)}
            to="/clients"
          >
            <span>Клиенты</span>
          </Link>
          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === "/managers" ? " active" : "")
            }
            onClick={() => setClientsOpen(false)}
            to="/managers"
          >
            <span>Менеджеры</span>
          </Link>
          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === "/orgs" ? " active" : "")
            }
            onClick={() => setClientsOpen(false)}
            to="/orgs"
          >
            <span>Курьеры</span>
          </Link>

        </div>
      </div>

      <div className={"menu-left-panel" + (productsOpen ? " active" : "")}>
        <div className="menu-left-panel-list">

          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === `/category/all` ? " active" : "")
            }
            onClick={() => setProductsOpen(false)}
            to={`/category/all`}
          >
            <span>Все категории</span>
          </Link>

          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === `/products/category/0` ? " active" : "")
            }
            onClick={() => setProductsOpen(false)}
            to={`/products/category/0`}
          >
            <span>Без категории</span>
          </Link>

          {categoriesList}

          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === `/add/category` ? " active" : "")
            }
            onClick={() => setProductsOpen(false)}
            to={`/add/category`}
          >
            <span>Создать категорию</span>
          </Link>

        </div>
      </div>


      <div className={"menu-left-panel" + (materialOpen ? " active" : "")}>
        <div className="menu-left-panel-list">
          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === "/material/list" ? " active" : "")
            }
            onClick={() => setMaterialOpen(false)}
            to="/material/list"
          >
            <span>Акции</span>
          </Link>

          <Link
            className={
              "menu-left-panel-item" +
              (location.pathname === "/material/all" ? " active" : "")
            }
            onClick={() => setMaterialOpen(false)}
            to="/material/all"
          >
            <span>Материалы</span>
          </Link>


        </div>
      </div>



    </div>
  );
}


export default connect(
  ({ category }) => ({ category }),
  {

  }
)(UiMenu);
